(() => {
if (window.__tBrushPageInteractionsLoaded) return;
window.__tBrushPageInteractionsLoaded = true;
const pillarPageContent = window.pageContent;
document.documentElement.dataset.pillarInteractions = "initializing";
const normalizeQuizKey = (value) => String(value || "")
  .trim()
  .toLowerCase()
  .replace(/\s+/g, "-")
  .replace(/[^a-z0-9_-]/g, "");

const initQuiz = (quizRoot) => {
  if (!quizRoot || quizRoot.dataset.tBrushQuizInitialized === "true") return;

  const quizConfig = pillarPageContent?.quiz || {};
  const configuredQuizOptions = quizConfig.diagnosticOptions || quizConfig.options || [];
  const quizButtons = [...quizRoot.querySelectorAll(".quiz-options button")];
  const seenKeys = new Set();
  const quizOptions = quizButtons.map((button, index) => {
    const legacyOption = configuredQuizOptions[index] || {};
    let id = normalizeQuizKey(button.dataset.optionId || legacyOption.id || `option-${index + 1}`);
    if (!id || seenKeys.has(id)) id = `option-${index + 1}`;
    seenKeys.add(id);
    button.dataset.optionId = id;
    return {
      id,
      issue: button.dataset.issue || legacyOption.issue || "",
      cause: button.dataset.cause || legacyOption.cause || "",
      priority: button.dataset.priority || legacyOption.priority || ""
    };
  });

  if (!quizOptions.length) return;

  const optionOrder = new Map(quizOptions.map((option, index) => [option.id, index]));
  const canonicalAnswerKey = (value) => {
    const values = Array.isArray(value) ? value : String(value || "").split("+");
    return [...new Set(values.map(normalizeQuizKey).filter(Boolean))]
      .sort((left, right) => (optionOrder.get(left) ?? 999) - (optionOrder.get(right) ?? 999))
      .join("+");
  };

  let rawSectionAnswers = [];
  try {
    rawSectionAnswers = JSON.parse(quizRoot.querySelector("[data-t-brush-quiz-answers]")?.textContent || "[]");
  } catch (error) {
    rawSectionAnswers = [];
  }

  const quizAnswers = {};
  if (Array.isArray(rawSectionAnswers)) {
    rawSectionAnswers.forEach((answer) => {
      const key = canonicalAnswerKey(answer.combination);
      if (key) quizAnswers[key] = answer;
    });
  } else {
    Object.entries(rawSectionAnswers || {}).forEach(([combination, answer]) => {
      const key = canonicalAnswerKey(combination);
      if (key) quizAnswers[key] = answer;
    });
  }

  if (!Object.keys(quizAnswers).length) {
    Object.entries(quizConfig.answers || {}).forEach(([combination, answer]) => {
      const key = canonicalAnswerKey(combination);
      if (key) quizAnswers[key] = answer;
    });
  }

  const quizMaxSelections = Math.max(1, Math.min(Number(quizRoot.dataset.maxSelections || quizConfig.maxSelections) || 2, 2));
  const quizPrompt = quizRoot.querySelector("[data-quiz-prompt], #quiz-prompt");
  const quizResult = quizRoot.querySelector("[data-quiz-result], .quiz-result");
  const quizAnswer = quizRoot.querySelector("[data-quiz-diagnosis], #quiz-diagnosis");
  const quizReason = quizRoot.querySelector("[data-quiz-cause], #quiz-cause");
  const quizPriority = quizRoot.querySelector("[data-quiz-priority], #quiz-priority");
  const quizPrompts = {
    prompt: quizPrompt?.textContent || quizConfig.prompt || "Select 1 or 2 concerns.",
    one: quizRoot.dataset.oneSelectedPrompt || quizConfig.oneSelectedPrompt || "Select one more concern for a combined result, or keep this answer.",
    two: quizRoot.dataset.twoSelectedPrompt || quizConfig.twoSelectedPrompt || "Two concerns selected. Deselect one to change your answer.",
    minimum: quizRoot.dataset.minimumPrompt || quizConfig.minimumPrompt || "Keep at least one concern selected.",
    maximum: quizRoot.dataset.maximumPrompt || quizConfig.maximumPrompt || "You can select up to two concerns. Deselect one before choosing another."
  };
  const selectedQuizIds = [];

  const setQuizPrompt = (message) => {
    if (!quizPrompt) return;
    quizPrompt.hidden = false;
    quizPrompt.textContent = message;
  };

  const renderQuizResult = () => {
    const selectedOptions = quizOptions.filter((option) => selectedQuizIds.includes(option.id));
    const answerKey = canonicalAnswerKey(selectedOptions.map((option) => option.id));
    const answer = selectedOptions.length === 1 ? selectedOptions[0] : quizAnswers[answerKey];

    quizButtons.forEach((button) => {
      const isSelected = selectedQuizIds.includes(button.dataset.optionId);
      button.classList.toggle("active", isSelected);
      button.setAttribute("aria-pressed", String(isSelected));
    });

    if (!answer || !selectedOptions.length) {
      if (quizResult) quizResult.hidden = true;
      setQuizPrompt(quizPrompts.prompt);
      return;
    }

    if (quizAnswer) quizAnswer.textContent = answer.issue || "";
    if (quizReason) quizReason.textContent = answer.cause || "";
    if (quizPriority) quizPriority.textContent = answer.priority || "";
    if (quizResult) {
      quizResult.hidden = false;
      quizResult.classList.add("has-profile");
    }
    setQuizPrompt(selectedOptions.length === quizMaxSelections ? quizPrompts.two : quizPrompts.one);
  };

  quizButtons.forEach((button) => {
    button.dataset.pillarBound = "true";
    button.addEventListener("click", () => {
      const optionId = button.dataset.optionId;
      const selectedIndex = selectedQuizIds.indexOf(optionId);

      if (selectedIndex >= 0) {
        if (selectedQuizIds.length === 1) {
          setQuizPrompt(quizPrompts.minimum);
          return;
        }
        selectedQuizIds.splice(selectedIndex, 1);
        renderQuizResult();
        return;
      }

      if (selectedQuizIds.length >= quizMaxSelections) {
        setQuizPrompt(quizPrompts.maximum);
        return;
      }

      selectedQuizIds.push(optionId);
      renderQuizResult();
    });
  });

  quizRoot.dataset.tBrushQuizInitialized = "true";
};

const initQuizzes = (scope = document) => {
  if (scope.matches?.("[data-t-brush-quiz-root], .quiz")) initQuiz(scope);
  scope.querySelectorAll?.("[data-t-brush-quiz-root], .quiz").forEach(initQuiz);
};

initQuizzes();
document.addEventListener("shopify:section:load", (event) => initQuizzes(event.target));

const dialog = document.querySelector("#story-dialog");
const dialogTitle = document.querySelector("#dialog-title");
const storyVideos = [...document.querySelectorAll(".story-video")];

document.querySelectorAll(".story-card").forEach((card) => {
  const video = card.querySelector(".story-video");
  const playButton = card.querySelector(".play");

  if (video) {
    const setPausedState = () => {
      card.classList.remove("is-playing");
      card.setAttribute("aria-label", card.getAttribute("aria-label").replace("Pause", "Play"));
    };

    const toggleVideo = () => {
      if (video.paused) {
        storyVideos.forEach((item) => {
          if (item !== video) item.pause();
        });
        video.play().catch(setPausedState);
      } else {
        video.pause();
      }
    };

    card.addEventListener("click", toggleVideo);
    card.addEventListener("keydown", (event) => {
      if (event.target !== card || !["Enter", " "].includes(event.key)) return;
      event.preventDefault();
      toggleVideo();
    });

    video.addEventListener("play", () => {
      card.classList.add("is-playing");
      card.setAttribute("aria-label", card.getAttribute("aria-label").replace("Play", "Pause"));
    });
    video.addEventListener("pause", setPausedState);
    video.addEventListener("ended", setPausedState);
    return;
  }

  card.addEventListener("click", () => {
    if (!dialog || !dialogTitle) return;
    dialogTitle.textContent = card.querySelector("h3").textContent.replace(/\s+/g, " ").trim();
    dialog.showModal();
  });
});

document.querySelectorAll(".video-carousel").forEach((carousel) => {
  if (carousel.dataset.videoControlsReady === "true") return;
  carousel.dataset.videoControlsReady = "true";
  const track = carousel.querySelector(".video-grid");
  const previousButton = carousel.querySelector('[data-video-direction="prev"]');
  const nextButton = carousel.querySelector('[data-video-direction="next"]');
  if (!track || !previousButton || !nextButton) return;

  const updateVideoControls = () => {
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const hasOverflow = maxScroll > 2;
    carousel.classList.toggle("has-overflow", hasOverflow);
    previousButton.disabled = !hasOverflow || track.scrollLeft <= 2;
    nextButton.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;
  };

  const moveVideoTrack = (direction) => {
    const firstCard = track.querySelector(".story-card");
    if (!firstCard) return;
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    const distance = firstCard.getBoundingClientRect().width + gap;
    track.scrollBy({ left: direction * distance, behavior: "smooth" });
  };

  previousButton.addEventListener("click", () => moveVideoTrack(-1));
  nextButton.addEventListener("click", () => moveVideoTrack(1));
  track.addEventListener("scroll", updateVideoControls, { passive: true });
  window.addEventListener("resize", updateVideoControls, { passive: true });
  window.requestAnimationFrame(updateVideoControls);
});

document.querySelector(".dialog-close")?.addEventListener("click", () => dialog?.close());
dialog?.addEventListener("click", (event) => {
  if (event.target === dialog) dialog.close();
});

const tipVideos = [...document.querySelectorAll(".tip-video")];

document.querySelectorAll(".tip-media").forEach((media) => {
  const video = media.querySelector(".tip-video");
  const playButton = media.querySelector(".tip-play");

  const setPausedState = () => {
    media.classList.remove("is-playing");
    playButton.setAttribute("aria-label", playButton.getAttribute("aria-label").replace("Pause", "Play"));
  };

  const toggleVideo = () => {
    if (video.paused) {
      tipVideos.forEach((item) => {
        if (item !== video) item.pause();
      });
      video.play().catch(setPausedState);
    } else {
      video.pause();
    }
  };

  playButton.addEventListener("click", toggleVideo);
  video.addEventListener("click", toggleVideo);
  video.addEventListener("play", () => {
    media.classList.add("is-playing");
    playButton.setAttribute("aria-label", playButton.getAttribute("aria-label").replace("Play", "Pause"));
  });
  video.addEventListener("pause", setPausedState);
  video.addEventListener("ended", setPausedState);
});

const pageVideos = [...storyVideos, ...tipVideos];
const networkConnection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
const shouldPreloadVideoData = !networkConnection?.saveData && !/^(slow-)?2g$/i.test(networkConnection?.effectiveType || "");

const warmVideo = (video) => {
  if (!video || video.dataset.preloadReady === "true") return;
  video.dataset.preloadReady = "true";
  video.removeAttribute("loading");
  video.preload = shouldPreloadVideoData ? "auto" : "metadata";
  video.setAttribute("preload", video.preload);
  if (video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) video.load();
};

if ("IntersectionObserver" in window) {
  const videoPreloadObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      warmVideo(entry.target);
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: "900px 220px 900px 220px",
    threshold: 0.01
  });

  pageVideos.forEach((video) => videoPreloadObserver.observe(video));
} else {
  pageVideos.slice(0, 2).forEach(warmVideo);
}

pageVideos.forEach((video) => {
  const interactionTarget = video.closest(".story-card, .tip-media") || video;
  interactionTarget.addEventListener("touchstart", () => warmVideo(video), { passive: true, once: true });
  interactionTarget.addEventListener("pointerenter", () => warmVideo(video), { passive: true, once: true });
});

const blogGrid = document.querySelector("#blog-grid");

if (blogGrid && Array.isArray(window.blogPosts)) {
  window.blogPosts.forEach((post) => {
    const card = document.createElement("article");
    card.className = "blog-card";
    card.innerHTML = `
      <a class="blog-image" href="${post.url}" aria-label="Read ${post.title}">
        <img src="${post.image}" alt="${post.imageAlt}" loading="lazy" />
      </a>
      <div class="blog-body">
        <div class="blog-meta">
          <time>${post.date}</time>
          <span>${post.readTime}</span>
        </div>
        <h3>${post.title}</h3>
        <p>${post.description}</p>
        <a class="button button-dark blog-read" href="${post.url}">Read Now</a>
      </div>
    `;
    blogGrid.appendChild(card);
  });
}

const productTrack = document.querySelector(".product-track");

const productNoteTimers = new WeakMap();
const getProductNoteTriggers = () => [...document.querySelectorAll(".product-note-trigger")];

const hideProductNote = (trigger) => {
  const note = document.getElementById(trigger.getAttribute("aria-controls"));
  window.clearTimeout(productNoteTimers.get(trigger));
  productNoteTimers.delete(trigger);
  trigger.setAttribute("aria-expanded", "false");
  note?.classList.remove("is-visible");
  note?.setAttribute("aria-hidden", "true");
};

document.addEventListener("click", (event) => {
    const trigger = event.target.closest(".product-note-trigger");
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();

    getProductNoteTriggers().forEach((item) => {
      if (item !== trigger) hideProductNote(item);
    });

    const note = document.getElementById(trigger.getAttribute("aria-controls"));
    window.clearTimeout(productNoteTimers.get(trigger));
    trigger.setAttribute("aria-expanded", "true");
    note?.classList.add("is-visible");
    note?.setAttribute("aria-hidden", "false");

    const timer = window.setTimeout(() => hideProductNote(trigger), 5000);
    productNoteTimers.set(trigger, timer);
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  getProductNoteTriggers().forEach(hideProductNote);
});

const comparisonScroll = document.querySelector(".comparison-scroll");

const enableHorizontalDrag = (scroller) => {
  if (!scroller) return;
  let isPointerDown = false;
  let isDragging = false;
  let startX = 0;
  let startScrollLeft = 0;
  let suppressClick = false;

  scroller.addEventListener("dragstart", (event) => event.preventDefault());
  scroller.addEventListener("pointerdown", (event) => {
    if (event.pointerType !== "mouse" || event.button !== 0) return;
    if (event.target.closest("a, button, input, select, textarea, [role='button']")) return;
    isPointerDown = true;
    isDragging = false;
    suppressClick = false;
    startX = event.clientX;
    startScrollLeft = scroller.scrollLeft;
    scroller.setPointerCapture(event.pointerId);
  });

  scroller.addEventListener("pointermove", (event) => {
    if (!isPointerDown) return;
    const distance = event.clientX - startX;
    if (!isDragging && Math.abs(distance) < 5) return;
    isDragging = true;
    suppressClick = true;
    scroller.classList.add("is-dragging");
    scroller.scrollLeft = startScrollLeft - distance;
    event.preventDefault();
  });

  const stopDrag = (event) => {
    if (!isPointerDown) return;
    isPointerDown = false;
    isDragging = false;
    scroller.classList.remove("is-dragging");
    if (scroller.hasPointerCapture(event.pointerId)) scroller.releasePointerCapture(event.pointerId);
    window.setTimeout(() => {
      suppressClick = false;
    }, 0);
  };

  scroller.addEventListener("pointerup", stopDrag);
  scroller.addEventListener("pointercancel", stopDrag);
  scroller.addEventListener("pointerleave", (event) => {
    if (isPointerDown && event.buttons === 0) stopDrag(event);
  });
  scroller.addEventListener("click", (event) => {
    if (!suppressClick) return;
    event.preventDefault();
    event.stopPropagation();
    suppressClick = false;
  }, true);
};

enableHorizontalDrag(productTrack);
enableHorizontalDrag(comparisonScroll);

const initPageNavigation = () => {
  const pageNavigation = document.querySelector("[data-t-brush-page-nav]");
  if (!pageNavigation) return;
  const pageNavigationSection = pageNavigation.closest(".t-brush-page-navigation-section");

  if (typeof window.__tBrushPageNavCleanup === "function") {
    window.__tBrushPageNavCleanup();
  }

  const pageNavLinks = [...pageNavigation.querySelectorAll("nav a[href^='#']")];
  const pageInternalLinks = [...pageNavigation.querySelectorAll("a[href^='#']")];
  const themeHeader = document.querySelector(".header-section")
    || document.querySelector("#header")?.closest(".shopify-section")
    || document.querySelector("#header");
  const announcementBar = document.querySelector(".announcement-bar-section")
    || document.querySelector(".announcement-bar")?.closest(".shopify-section")
    || document.querySelector(".announcement-bar");
  const mobileMenuToggle = document.querySelector(".mobile-toggle-wrapper");
  const headerNavContainer = document.querySelector(".header-nav-container");
  const eventController = new AbortController();
  const { signal } = eventController;
  let scrollFrame = null;
  let mobileMenuObserver = null;
  let headerNavMenuObserver = null;
  let mobileMenuBodyObserver = null;

  const getMobileDrawer = () => document.querySelector("[id^='mobile-nav-wrapper-'].active")
    || document.querySelector("[id^='mobile-nav-wrapper-']");

  const resetMobileDrawerPosition = () => {
    const mobileDrawer = getMobileDrawer();
    if (!mobileDrawer) return;
    mobileDrawer.style.removeProperty("top");
    mobileDrawer.style.removeProperty("height");
    mobileDrawer.style.removeProperty("max-height");
  };

  const syncMobileDrawerPosition = (menuOpen) => {
    const mobileDrawer = getMobileDrawer();
    const currentHeaderNav = document.querySelector(".header-nav-container");
    if (!mobileDrawer || !currentHeaderNav) return;

    if (!menuOpen || window.innerWidth > 991) {
      resetMobileDrawerPosition();
      return;
    }

    const headerBottom = Math.max(0, Math.round(currentHeaderNav.getBoundingClientRect().bottom));
    /*
     * The theme header establishes a containing block for its fixed drawer on
     * some mobile browsers. In that case `top` is local to the header section,
     * not the viewport. Measure that origin explicitly so the announcement bar
     * is not counted twice (the duplicate offset exposed a strip of the hero).
     */
    mobileDrawer.style.setProperty("top", "0px", "important");
    const drawerContainingBlockTop = Math.round(mobileDrawer.getBoundingClientRect().top);
    const drawerTop = Math.max(0, headerBottom - drawerContainingBlockTop);
    const availableHeight = Math.max(0, Math.round(window.innerHeight - headerBottom));
    mobileDrawer.style.setProperty("top", `${drawerTop}px`, "important");
    mobileDrawer.style.setProperty("height", `${availableHeight}px`, "important");
    mobileDrawer.style.setProperty("max-height", `${availableHeight}px`, "important");
  };

  themeHeader?.classList.add("t-brush-theme-header-controlled");
  announcementBar?.classList.add("t-brush-theme-announcement-controlled");

  const isMobileMenuOpen = () => {
    const currentMobileMenuToggle = document.querySelector(".mobile-toggle-wrapper");
    const currentHeaderNav = document.querySelector(".header-nav-container");
    return Boolean(
      document.body.classList.contains("overflow-hidden")
      || document.body.classList.contains("is-header-nav-layer-active")
      || document.body.style.overflow === "hidden"
      || currentHeaderNav?.classList.contains("is-mobile-menu-open")
      || currentHeaderNav?.classList.contains("is-mobile-submenu")
      || (currentMobileMenuToggle
        && (currentMobileMenuToggle.hasAttribute("open") || currentMobileMenuToggle.classList.contains("active")))
    );
  };

  const syncNavigation = () => {
    const menuOpen = isMobileMenuOpen();
    const isPastHalfScreen = Math.max(window.scrollY, 0) >= window.innerHeight * 0.5;
    const showPageNavigation = isPastHalfScreen && !menuOpen;

    pageNavigation.classList.toggle("is-stuck", showPageNavigation);
    pageNavigation.classList.toggle("is-mobile-menu-open", menuOpen);
    pageNavigation.classList.remove("is-at-top", "is-scrolled", "is-hidden", "has-visible-theme-header");
    pageNavigation.style.removeProperty("--t-brush-theme-header-offset");
    pageNavigationSection?.classList.toggle("is-mobile-menu-open", menuOpen);
    pageNavigation.setAttribute("aria-hidden", showPageNavigation ? "false" : "true");

    themeHeader?.classList.toggle("is-t-brush-hidden", showPageNavigation);
    announcementBar?.classList.toggle("is-t-brush-hidden", showPageNavigation);
    syncMobileDrawerPosition(menuOpen);
    scrollFrame = null;
  };

  const scheduleNavigationSync = () => {
    if (!scrollFrame) scrollFrame = window.requestAnimationFrame(syncNavigation);
  };

  document.addEventListener("click", (event) => {
    if (event.target.closest?.("#mobile-nav-toggle, #mobile-nav-close, .mobile-toggle")) {
      pageNavigation.classList.remove("is-stuck");
      pageNavigation.setAttribute("aria-hidden", "true");
      window.setTimeout(syncNavigation, 0);
      window.setTimeout(syncNavigation, 60);
      window.setTimeout(syncNavigation, 160);
      window.setTimeout(syncNavigation, 420);
      window.setTimeout(syncNavigation, 800);
    }
  }, { capture: true, signal });

  if (mobileMenuToggle && "MutationObserver" in window) {
    mobileMenuObserver = new MutationObserver(scheduleNavigationSync);
    mobileMenuObserver.observe(mobileMenuToggle, { attributes: true, attributeFilter: ["open", "class"] });
  }
  if (headerNavContainer && "MutationObserver" in window) {
    headerNavMenuObserver = new MutationObserver(scheduleNavigationSync);
    headerNavMenuObserver.observe(headerNavContainer, { attributes: true, attributeFilter: ["class"] });
  }
  if ("MutationObserver" in window) {
    mobileMenuBodyObserver = new MutationObserver(scheduleNavigationSync);
    mobileMenuBodyObserver.observe(document.body, { attributes: true, attributeFilter: ["class", "style"] });
  }
  syncNavigation();
  window.addEventListener("resize", scheduleNavigationSync, { passive: true, signal });
  window.addEventListener("scroll", scheduleNavigationSync, { passive: true, signal });

  pageInternalLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      const selector = link.getAttribute("href");
      const target = selector?.startsWith("#") ? document.getElementById(selector.slice(1)) : null;
      if (!target) return;
      event.preventDefault();
      if (window.Shopify?.designMode) event.stopPropagation();
      const isTopLink = selector === "#top";
      const navOffset = isTopLink ? 0 : pageNavigation.offsetHeight + 10;
      const targetTop = isTopLink
        ? 0
        : target.getBoundingClientRect().top + window.scrollY - navOffset;
      window.scrollTo({ top: Math.max(0, targetTop), behavior: "smooth" });
      if (window.history?.replaceState) window.history.replaceState(null, "", selector);
    }, { capture: true, signal });
  });

  const observedSections = pageNavLinks
    .map((link) => document.querySelector(link.getAttribute("href")))
    .filter(Boolean);

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      pageNavLinks.forEach((link) => {
        const isActive = link.getAttribute("href") === `#${entry.target.id}`;
        link.classList.toggle("is-active", isActive);
        if (isActive) link.setAttribute("aria-current", "location");
        else link.removeAttribute("aria-current");
      });
    });
  }, { rootMargin: "-25% 0px -60%", threshold: 0 });

  observedSections.forEach((section) => sectionObserver.observe(section));

  pageNavigation.dataset.navigationReady = "true";
  window.__tBrushPageNavCleanup = () => {
    eventController.abort();
    mobileMenuObserver?.disconnect();
    headerNavMenuObserver?.disconnect();
    mobileMenuBodyObserver?.disconnect();
    sectionObserver.disconnect();
    if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
    resetMobileDrawerPosition();
    themeHeader?.classList.remove("is-t-brush-hidden");
    announcementBar?.classList.remove("is-t-brush-hidden");
  };
};

initPageNavigation();

if (!window.__tBrushSectionReloadBound) {
  document.addEventListener("shopify:section:load", () => {
    window.requestAnimationFrame(initPageNavigation);
  });
  window.__tBrushSectionReloadBound = true;
}
document.documentElement.dataset.pillarInteractions = "ready";
})();
